// all の中に part が出現する回数を取得

export const strCount = (all, part) => {
  return (all.match(new RegExp(part, 'g')) || []).length;
};
